<script setup>
import { onMounted, onUpdated, ref, defineProps} from 'vue'
import { useRouter } from "vue-router"
import { KNOLIA }         from '@/knolia'
import { Gems }           from '@/gems'
import { MESSAGES }       from '@/messages'
import SearchCriteriaEnum from "@/enums/SearchCriteria"
import { useDragAndDrop } from '../store/modules/drag-and-drop'
import DropZone from './DropZone.vue'
import BaseSelect from "./BaseSelect.vue";
import { useUserStore } from '../store/modules/user'

const router = useRouter()
const props = defineProps({
    searchUsersStore: {
        default: Object,
        type: Object
    },
})
const searchCriteriaInput  = ref(null)
const selectedCriteriaType = ref(null)
const showActivities       = ref(true)
const showSkillsOp         = ref(true)
const dragAndDrop          = useDragAndDrop()
const dropZone             = ref(null)
const showAllTasks         = ref(false)
const showAllOpSkills      = ref(false)
const isLowerThanMobile    = ref(KNOLIA.updateIsLowerThanMobile())
const isMobile             = ref(KNOLIA.updateIsMobile())
const userStore            = useUserStore()

let listName               = ref('')
let checkedTasks           = []

onMounted(() => {
    DefineDropFunction()

    window.addEventListener('resize', () => {
        isMobile.value = KNOLIA.updateIsMobile()
        isLowerThanMobile.value = KNOLIA.updateIsLowerThanMobile()
    })

    if(props.searchUsersStore.UsersFound) {
        SetCriteriasTooltipsAndDrag()
    }
})

onUpdated(() => {
    SetCriteriasTooltipsAndDrag()
})

function SetCriteriasTooltipsAndDrag() {
    props.searchUsersStore.Criterias.forEach(criteria => {
        let row = document.getElementById(`criteria-${criteria.id}`)
        
        if(row) {
            if(criteria.sitemap)
                Gems.Tooltip(row, criteria.sitemap, 'tooltip tooltip-left')

            dragAndDrop.setDragFunctionElem(function () {
                dragAndDrop.setDraggedData({criteria})
            }, row)
        }
    })
}

function UserInfoTooltip(user, divUser) {
    let tooltipText = `Competência | Proficiência | Percentagem\r\n\r\n`

    user.skill_ops.forEach(criterias => {
        if(criterias.proficiency)
            tooltipText += `${criterias.skill_op_name} | ${criterias.proficiency} | ${criterias.validation_percent}%\r\n`
    })

    Gems.Tooltip(divUser, tooltipText, 'tooltip tooltip-left')
}


function DefineDropFunction() {
    dragAndDrop.setDropFunction(async function() {
        const criteria = dragAndDrop.draggedData.criteria

        const response = await KNOLIA.CallBackEnd('post', 'get-criteria-list', {
            id: criteria.id,
            type: criteria.type
        })
        
        if(response.data.error) {
            Gems.Telegram(MESSAGES.ERROR.DEFAULT, 'tele-not-allowed')
            return
        }

        const expandedCriterias = props.searchUsersStore.ExpandedCriterias

        props.searchUsersStore.mergeRequestIntoFinal(expandedCriterias.activities, response.data.activities)
        
        props.searchUsersStore.mergeRequestIntoFinal(expandedCriterias.skills, response.data.skills)

        props.searchUsersStore.setExpandedCriterias(expandedCriterias)

    }, dropZone.value)
}

async function SearchCriterias() {
    if(selectedCriteriaType.value == null) {
        Gems.Telegram(MESSAGES.ERROR.TYPE_UNCHOSEN, 'tele-not-allowed')
        return 
    }
    
    props.searchUsersStore.setCriterias([])

    const response = await KNOLIA.CallBackEnd('post', 'search-criteria', {
        criteria: selectedCriteriaType.value,
        searchField: searchCriteriaInput.value.value
    })

    props.searchUsersStore.setCriterias(response.data)
}

function GetSelectedSkillsOp() {
    const selectedOpSkills = []
    props.searchUsersStore.ExpandedCriterias?.skills?.filter(skill => {
        skill.children.forEach(child => {
            if(child.checked)
                selectedOpSkills.push({
                    skill_op_id: child.id,
                    proficiency: child.selected_proficiency
                })
        })
    })
    return selectedOpSkills
}   

async function SearchUsers() {
    const response = await KNOLIA.CallBackEnd('post', 'search-users-by-criterias', {
        criterias: GetSelectedSkillsOp(),
    })

    props.searchUsersStore.setUsersFound(response.data)
}

function OpSkillCanStayChecked(opSkill, taskList) {
    return opSkill.checked && checkedTasks.some(taskId => taskList.includes(JSON.stringify(taskId)))
}

function CheckOpSkillByTask(task, arrSkillOp) {
    props.searchUsersStore.ExpandedCriterias.skills.forEach(skill => {
        skill.children.forEach(child => {
            const tasks = child.task_id?.split(',')
            if(tasks?.includes(`${task.id}`)) {
                child.checked = !task.checked ? OpSkillCanStayChecked(child, tasks) : task.checked
                arrSkillOp.push(child)
            }
        })
    })

    return arrSkillOp
}

function CheckActivities(activity) {
    let skillOp = []

    activity.children.forEach(task => {
        task.checked = activity.checked
        if(!activity.checked) {
            activity.childUnchecked = false
            task.childUnchecked = false
        }

        if(task.checked) {
            checkedTasks.push(task.id)
        } else {
            checkedTasks = checkedTasks.filter(a => a !== task.id)
        }

        skillOp = CheckOpSkillByTask(task, skillOp)
    })

    skillOp.forEach(elem => {
        CheckSkillsOp(null, elem)
    })
    
    SearchUsers()
}

function CheckTasks(ev, task) {
    let skillOp = []
    
    if(task.checked) {
        checkedTasks.push(task.id)
    } else {
        task.childUnchecked = false
        checkedTasks = checkedTasks.filter(a => a !== task.id)
    }

    skillOp = CheckOpSkillByTask(task, skillOp)

    if(ev.isTrusted) {
        skillOp.forEach(elem => {
            CheckSkillsOp(null, elem)
        })

        props.searchUsersStore.ExpandedCriterias.activities.forEach(activity => {
            if(activity.id == task.parent_id) {
                let childCount = 0
                let selectedCount = 0
                activity.children.forEach(child => {
                    childCount++

                    if(child.checked)
                        selectedCount++
                })

                activity.checked = childCount == selectedCount

                if(selectedCount == 0)
                    activity.childUnchecked = false
            }
        })
        SearchUsers()
    }
}

function ChangeTaskproficiency(task, assignmentLevel) {
    task.participation_level = assignmentLevel
    task.assignment_criteria = task.assignment_criteria ?? 1

    let skillOps = []
    let selectedAssignment = task.assignment_ddl.filter(assignment => assignment.level == assignmentLevel)[0]

    selectedAssignment = task.assignment_criteria == 0 ? selectedAssignment.min : selectedAssignment.ideal

    props.searchUsersStore.ExpandedCriterias.skills.forEach(skill => {
        skill.children.forEach(skillOp => {
            if (skillOp.task_id == task.id)
                skillOps.push(skillOp)
        })
    })


    skillOps.forEach(skillOp => {
        if (assignmentLevel == 3)
            skillOp.proficiency_ddl[0].hide = true
        else
            skillOp.proficiency_ddl[0].hide = false

        skillOp.selected_proficiency = skillOp.proficiency_ddl.filter(prof => selectedAssignment >= prof.min).reverse()[0]?.id
    })

    SearchUsers()
}

function ChangeTaskproficiencyCriteria(task, executionCriteria) {
    task.assignment_criteria = executionCriteria
    task.participation_level = task.participation_level ?? 1

    let skillOps = []
    let selectedAssignment = task.assignment_ddl.filter(assignment => assignment.level == task.participation_level)[0]

    selectedAssignment = executionCriteria == 0 ? selectedAssignment.min : selectedAssignment.ideal

    props.searchUsersStore.ExpandedCriterias.skills.forEach(skill => {
        skill.children.forEach(skillOp => {
            if (skillOp.task_id == task.id)
                skillOps.push(skillOp)
        })
    })

    skillOps.forEach(skillOp => {
        if (executionCriteria == 0)
            skillOp.proficiency_ddl[0].hide = false

        const selected_proficiency = skillOp.proficiency_ddl.filter(prof => selectedAssignment >= prof.min).reverse()[0]

        skillOp.selected_proficiency = selected_proficiency ? selected_proficiency.id : 1
    })

    SearchUsers()
}

function CheckSkills(ev, skillId) {
    
    props.searchUsersStore.ExpandedCriterias.skills.forEach(skill => {
        if(skill.id == skillId) {
            skill.children.forEach(opSkill => {
                opSkill.checked = skill.checked
                CheckStyleForUncheckedTasks(opSkill)
            })
        }
    })

    if(ev.isTrusted)
        SearchUsers()
}

function CheckSkillsOp(ev, opSkill) {
    props.searchUsersStore.ExpandedCriterias.skills.forEach(skill => {
        if(skill.id == opSkill.parent_id) {
            let childCount = 0
            let selectedCount = 0
            skill.children.forEach(child => {
                childCount++

                if(child.checked)
                    selectedCount++
            })

            skill.checked = childCount == selectedCount
        }
    })
    CheckStyleForUncheckedTasks(opSkill)

    if(ev?.isTrusted) 
        SearchUsers()
}

function CheckStyleForUncheckedTasks(opSkill) {
    if(props.searchUsersStore.ExpandedCriterias.activities.length > 0) {
        const tasks = opSkill.task_id?.split(',')
        props.searchUsersStore.ExpandedCriterias.activities.forEach(activity => {
            activity.children.forEach(task => {
                if(tasks?.includes(`${task.id}`) && task.checked) {
                    task.childUnchecked = opSkill.checked ? false : true
                    activity.childUnchecked = opSkill.checked ? false : true
                }
            })
        })
    }
}
 

async function SaveList() {
    if(!listName.value){
        Gems.Telegram(MESSAGES.ERROR.LIST_UNNAMED, 'tele-not-allowed')
        return
    }

    let criterias = []
    
    props.searchUsersStore.ExpandedCriterias.skills.forEach(skill => {
        skill.children.forEach(child => {
            if(child.checked)
                criterias.push(`${child.designation} [${child.proficiency_ddl[child.selected_proficiency-1].designation}]`)
        })
    })

    const response = await KNOLIA.CallBackEnd('post', 'save-users-list', {
        listName: listName.value,
        users: props.searchUsersStore.UsersFound,
        criterias
    })

    if(response.error) {
        Gems.Telegram(MESSAGES.ERROR.DEFAULT, 'tele-not-allowed')
        return
    }

    Gems.Telegram(MESSAGES.SUCCESS.SAVED, 'tele-success')
    listName.value = ''
}

function ShowAllChildren(type) {
    if(type == SearchCriteriaEnum.ACTIVITIES) {
        showAllTasks.value = !showAllTasks.value
        props.searchUsersStore.ExpandedCriterias.activities.forEach(activity => activity.show_tasks = showAllTasks.value)
    } else {
        showAllOpSkills.value = !showAllOpSkills.value
        props.searchUsersStore.ExpandedCriterias.skills.forEach(skill => skill.show_skills_op = showAllOpSkills.value)
    }
}

function CanShowTooltip(elem, htmlElem) {
    if(!elem.operative_skills_count)
        Gems.Tooltip(htmlElem, 'Sem competências operativas para filtrar', 'tooltip')
}

function ToSkillCard(user) {
    KNOLIA.SetRequestedUserId(user.user_id)
    router.push('/skill-card')
}
</script>


<template>

    <div>
        <div class="row p-0 m-0 pt-3 pb-2 align-items-center">
            <div class="col-12 col-sm-6 col-md-4 p-0 m-0">
                <base-select v-model="selectedCriteriaType" class="w-100 alt-ddl" :class="{'ddl-alt-padding': isMobile || isLowerThanMobile}">
                    <option value="">Pesquisar por</option>
                    <option :value="SearchCriteriaEnum.USERS">Pessoas</option>
                    <option :value="SearchCriteriaEnum.SKILLS">Competência</option>
                    <option :value="SearchCriteriaEnum.ACTIVITIES">Atividades</option>
                    <option :value="SearchCriteriaEnum.JOBS">Funções</option>
                </base-select>
            </div>

            <div class="col-10 col-sm-5 p-0 m-0 ps-sm-2 pt-2 pt-sm-0" :class="{'div-web-view-container': !isMobile && !isLowerThanMobile}">
                <input ref="searchCriteriaInput" type="text" class="form-control w-100" :class="{'ddl-alt-padding': isMobile || isLowerThanMobile}" placeholder="" />
            </div>

            <div class="col-2 col-sm-1 ps-4 ps-sm-2 pt-2 pt-sm-0" :class="{'div-web-view-container': !isMobile && !isLowerThanMobile}">
                <i class="bi bi-search fs-4 fs-sm-3" role="button" @click="SearchCriterias()"></i>
            </div>
        </div>

        <div id="div-criteria-result-container" class="row p-0 m-0 pt-3">

            <div class="col-12 col-sm-6 col-md-4 p-0 pb-2 m-0">
                <div id="div-criteria-result-container-header">
                    <div class="group-name">
                        <label class="div-default-title">Listagem</label>
                    </div>
                </div>

                <div class="scrollbar group-frame">
                    <div draggable="true" class="div-criteria default-radius" :class="{'bg-alt-line': i % 2 == 0}" 
                        v-for="(criteria, i) in props.searchUsersStore.Criterias" :key="criteria.id" :id="`criteria-${criteria.id}`">
                        {{ criteria.name }}
                    </div>
                </div>
            </div>

            <div class="col-12 col-sm-6 col-md-8 p-0 pb-2 m-0" :class="{'div-web-view-container': !isMobile && !isLowerThanMobile}">
                <div class="div-expanded-criterias-header group-name">
                    <div class="criterias-title">
                        <label class="criterias div-default-title" @mouseenter="Gems.Tooltip($event.target, 'Quantidade de competências operativas selecionadas', 'tooltip')">
                            Critérios [{{ GetSelectedSkillsOp().length ?? 0 }}]
                        </label>
                    </div>
                    <span class="cursor-pointer clear"  @click="props.searchUsersStore.ResetSearchUsers()">Limpar</span>
                </div>

                <div class="scrollbar group-frame">
                    <div ref="dropZone">
                        <DropZone id="drop-zone"/>
                    </div>

                    <div class="div-criterias-header default-radius">
                        <div>
                            <i class="fas show-children cursor-pointer" :class="{'fa-chevron-down': !showActivities , 'fa-chevron-up': showActivities}" 
                            @click="showActivities = !showActivities"></i>
                            Atividades
                        </div>

                        <div class="cursor-pointer" @click="ShowAllChildren(SearchCriteriaEnum.ACTIVITIES)">
                            Expandir/Fechar todos
                        </div>
                    </div>

                    <div v-for="activity in searchUsersStore.ExpandedCriterias.activities" :key="activity.id" :activity-id="activity.id" v-show="showActivities">
                        <div class="div-activity bg-alt-line default-radius" :class="{'child-unchecked': activity.childUnchecked, 'without-op-skill': !activity.operative_skills_count}">
                            <i class="fas show-children cursor-pointer" :class="{'fa-chevron-down': !activity.show_tasks , 'fa-chevron-up': activity.show_tasks}" 
                                @click="activity.show_tasks = !activity.show_tasks"></i>
                            <div class="div-checkbox">
                                <input type="checkbox" @change="CheckActivities(activity)" v-model="activity.checked" v-show="activity.operative_skills_count">
                            </div>
                            <span class="line-clamp line-clamp-1">{{ activity.designation }}</span>
                        </div>

                        <div class="div-task" :class="{'child-unchecked': task.childUnchecked, 'without-op-skill': !task.operative_skills_count}" v-for="(task) in activity.children" :key="task.id" :parent-activity-id="activity.id"
                            :task-id="task.id" v-show="activity.show_tasks" @mouseenter="CanShowTooltip(task, $event.target)">

                            <div class="div-task-input">
                                <div class="div-checkbox">
                                    <input type="checkbox" @change="CheckTasks($event, task)" v-model="task.checked" v-show="task.operative_skills_count">
                                </div>
                                <span class="line-clamp line-clamp-1">{{ task.designation }}</span>
                            </div>

                            <div class="div-task-assignment-level" v-show="task.operative_skills_count">
                                <base-select class="sel-assignment-level ddl-alt-padding" @change="ChangeTaskproficiency(task, $event.target.value)">
                                    <option v-for="assignment in task.assignment_ddl" :key="assignment.level" :value="assignment.level">{{ assignment.designation }}</option>
                                </base-select>

                                <base-select class="sel-prof-level ddl-alt-padding" @change="ChangeTaskproficiencyCriteria(task, $event.target.value)">
                                    <option value="0">Min</option>
                                    <option value="1">Padrão</option>
                                </base-select>
                            </div>
                        </div>
                    </div>

                    <div class="div-criterias-header-last default-radius">
                        <div>
                            <i class="fas show-children cursor-pointer" :class="{'fa-chevron-down': !showSkillsOp , 'fa-chevron-up': showSkillsOp}" 
                                @click="showSkillsOp = !showSkillsOp"></i>
                            Competências (Critérios de pesquisa)
                        </div>

                        <div class="cursor-pointer" @click="ShowAllChildren(SearchCriteriaEnum.SKILLS)">
                            Expandir/Fechar todos
                        </div>
                    </div>

                    <div v-for="skill in searchUsersStore.ExpandedCriterias.skills" :key="skill.id" :skill-id="skill.id" v-show="showSkillsOp">
                        <div class="div-skill bg-alt-line default-radius" :class="{'without-op-skill': !skill.operative_skills_count}" @mouseenter="CanShowTooltip(skill, $event.target)">
                            <i class="fas show-children cursor-pointer" :class="{'fa-chevron-down': !skill.show_skills_op , 'fa-chevron-up': skill.show_skills_op}" 
                                @click="skill.show_skills_op = !skill.show_skills_op" v-show="skill.operative_skills_count"></i>

                            <div class="div-checkbox">
                                <input :checked="skill.checked" type="checkbox" @change="CheckSkills($event, skill.id)" v-model="skill.checked" v-show="skill.operative_skills_count">
                            </div>

                            <span class="line-clamp line-clamp-1">{{ skill.designation }}</span>
                        </div>

                        <div class="div-skill-op" v-for="(skillOp) in skill.children" :key="skillOp.id"
                            :parent-skill-id="skill.id" :parent-task-id="skillOp.task_id" v-show="skill.show_skills_op">
                            <div class="div-task-input">
                                <div class="div-checkbox">
                                    <input :checked="skillOp.checked" type="checkbox" :skill-op-id="skillOp.id" @change="CheckSkillsOp($event, skillOp)"
                                        v-model="skillOp.checked">
                                </div>
                                
                                <span class="line-clamp line-clamp-1">{{ skillOp.designation }}</span>
                            </div>

                            <div class="div-skill-op-ddl">
                                <base-select class="sel-skill-op-proficiency ddl-alt-padding " v-model="skillOp.selected_proficiency" @change="SearchUsers">
                                    <option v-show="!prof.hide" v-for="prof in skillOp.proficiency_ddl" :key="prof.id" :value="prof.id">
                                        {{ prof.designation }}
                                    </option>
                                </base-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="group-name lbl-users">
            <span class="div-default-title">Resultado da pesquisa [pessoas]</span>
            <div class="div-save-list" v-show="props.searchUsersStore.UsersFound.length > 0">
                <input type="text" class="ddl-alt-padding" placeholder="[nome da lista]" v-model="listName">
                <i class="bi bi-floppy2-fill fs-5 cursor-pointer" @click="SaveList()" />
            </div>
        </div>

        <div class="scrollbar group-frame">
            <div class="div-user-header row">
                <span class="col-3">Nome</span>
                <span class="col-3 fw-bold line-clamp line-clamp-1">Proficiência <span class="fw-normal">[Média]</span>
                    <i class="bi bi-info-circle-fill ps-1" 
                        @mouseenter="Gems.Tooltip($event.target, 'Instruente: 1 a 8 \r\nCompetente: 9 a 20\r\nProficiente: 24 a 36', 'tooltip')"></i> 
                </span>
                <span class="col-3 fw-bold line-clamp line-clamp-1">Ajustamento médio ao requisito 
                    <i class="bi bi-info-circle-fill ps-1" 
                        @mouseenter="Gems.Tooltip($event.target, 'A percentagem em que a proficiência média detida corresponde aos critérios definidos na pesquisa', 'tooltip')"></i>
                </span>
                <span class="col-2">Cobertura</span>
                <span class="col-1 line-clamp line-clamp-1" v-if="userStore.User.can_check_skill_cards || KNOLIA.isAdmin()">Cédula</span>
            </div>

            <div class="div-user cursor-default default-radius row" :class="{'bg-alt-line': i % 2 == 0}" v-for="(user, i) in props.searchUsersStore.UsersFound" :key="user.user_id" @mouseenter="UserInfoTooltip(user, $event.target)">
                <span class="col-3 user-name">{{ user.name }}</span>
                <span class="col-3">{{ user.proficiency_average ?? '--'}}</span>
                <span class="col-3">{{ `${user.validation_percent ?? '0.00'}%` }}</span>
                <span class="col-2">{{`${user.rated_count} / ${user.total_op_skills}`}}</span>
                <i class="col-1 fas fa-address-card cursor-pointer align-content-center" @mouseenter="Gems.Tooltip($event.target, 'Cédula de competências', 'tooltip')"
                 @click="ToSkillCard(user)" v-if="user.is_logged_user || userStore.User.can_check_skill_cards || KNOLIA.isAdmin() || (!userStore.User.can_check_skill_cards && user.is_subordinate)"></i>
            </div>
        </div>
    </div>
</template>

<style scoped>

#div-skills {
    margin-top: 10px;
}

#div-criterias {
    display: flex;
    justify-content: space-between;
    margin-right: 10px;
}

#div-criterias>div {
    border: 1px solid;
    border-radius: 5px;
    padding: 5px;
    cursor: pointer;
}

.select-criteria-type {
    width: 125px;
}

.div-search-criterias {
    display: flex;
}

.div-search-criterias,
.div-search-criterias input {
    flex: 2;
    width: --webkit-fill-available;
}

.btn-search-criteria {
    /* margin-left: 5px; */
    width: 45px;
}

#div-search-criterias-container {
    display: flex;
    margin-bottom: 1%;
    align-items: center;
    justify-content: space-between;
}

.div-criterias-header,
.div-criterias-header-last {
    /* color: #120d19; */
    /* background-color: #afcdff30; */
    /* color: #1e232f; */
    /* opacity: .5; */
    /* color: var(--knolia-grayish-black); */
    background-color: #adcbff17;
    padding: 5px;
    font-size: .9em;
    border-radius: 20px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    font-weight: bold;
}

.div-criterias-header-last {
    margin-top: 10px;
}

.group-frame  {
    overflow-y: scroll;
    overflow-x: hidden;
    height: 33vh;
}

#div-criteria-result-container {
    margin-bottom: 2%;
}

#div-criteria-result-container {
    margin-top: 1%;
}

#div-criteria-result-container,
#div-criteria-result-container-header {
    /* display: flex; */
    align-items: center;
    /* gap: 2%; */
}

#div-search-users {
    display: flex;
}

#div-left-criteria {
    display: flex;
    width: 35%;
    align-items: center;
}

.div-activity:last-child {
    margin-bottom: 5px;
}

.div-activity,
.div-skill {
    margin-bottom: 2px;
}

.div-task, .div-skill-op {
    justify-content: space-between;
    padding: 1px 5px 1px 25px !important;
}

.div-skill,
.div-activity,
.div-criteria,
.div-task,
.div-skill-op,
.div-user { 
    padding: 5px;
    display: flex;
    gap: 2px;
}

.div-task {
    gap: 0px;
}

.div-user-header {
    font-weight: bold;
    margin-top: -5px;
    margin-bottom: 5px;
}

.div-user {
    padding: 5px 0px;
}

.div-user,
.div-user-header {
    gap: 0;
    text-align: center;
}

.div-task-input {
    align-self: center;
    display: flex;
    gap: 2px;
}

.div-criteria {
    cursor: grab !important;
}

.div-criteria,
.div-task-input input,
.div-skill-op input,
.div-activity input,
.div-skill input {
    cursor: pointer;
}

.div-criteria:hover,
.div-user:hover {
    color: var(--default-app-hover-color);
}

.user-name {
    text-align: start !important;
}

.div-default-title {
    font-size: inherit;
}

.group-name {
    font-weight: bold;
    align-self: flex-end;
    margin-bottom: 2px;
}

.div-web-view-container {
    padding-left: 1% !important;
}

/* .criterias, */
.div-expanded-criterias-header button {
    margin-right: 5px;
    width: 80px;
}

.criterias-title {
    display: flex;
}

.criterias {
    align-self: flex-end;
}

.clear:hover {
    color: var(--default-app-hover-color);
}

.lbl-users {
    align-items: end;
}

.div-expanded-criterias-header,
.lbl-users {
    display: flex;
    justify-content: space-between;
}

.div-task-assignment-level,
.div-skill-op-ddl {
    width: 193px;
}

.div-task-assignment-level {
    display: flex;
    gap: 5px;
}

.sel-skill-op-proficiency {
    width: 100%;
}

.child-unchecked {
    color: orangered;
    border-color: orangered;
}

.without-op-skill {
    opacity: .5;
    cursor: default;
}

.div-checkbox {
    width: 13px;
    height: 13px;
    margin: 3px 7px 3px 3px;
}

.show-children {
    align-content: center;
}

.div-save-list {
    display: flex;
    gap: 10px;
    align-items: center;
    padding-bottom: 5px;
}

.div-save-list input {
    width: 300px;
}

@media screen and (max-width: 765px) {

    .div-task, .div-skill-op {
        padding: 3px 5px 3px 16px !important;
    }

    .div-task-assignment-level, .div-skill-op-ddl {
        width: -webkit-fill-available;
        text-align: end;
    }

    .div-task-input {
        width: 50%;
    }

    .div-skill-op .div-task-input {
        width: 80%;
    }
    
    .sel-skill-op-proficiency {
        width: unset;
    }
    
}

</style>
